import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/support", label: "Support" },
  { to: "/privacy", label: "Privacy" },
  { to: "/terms", label: "Terms" },
];

export const Navbar = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-black/70 border-b border-amber-500/15"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between">
        <Link
          to="/"
          data-testid="navbar-logo-link"
          className="flex items-center gap-3 group"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_irl-stats-launch/artifacts/11a33vjr_irl%20stats%201.png"
            alt="IRL Stats logo"
            className="h-10 w-10 rounded-lg shadow-[0_0_18px_-4px_rgba(251,191,36,0.45)]"
          />
          <span className="font-cinzel text-amber-100 text-base sm:text-lg tracking-[0.18em] uppercase">
            IRL Stats
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={`text-sm tracking-wider uppercase transition-colors ${
                pathname === l.to
                  ? "text-amber-300"
                  : "text-stone-300 hover:text-amber-200"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <button
          data-testid="navbar-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-amber-200 p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="md:hidden border-t border-amber-500/10 bg-black/95"
        >
          <div className="flex flex-col px-6 py-4 gap-4">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className={`text-sm tracking-wider uppercase ${
                  pathname === l.to ? "text-amber-300" : "text-stone-300"
                }`}
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
